import PageLayout from './PageLayout';
import { OurStory } from '@/components/wedding';

const OurStoryPage = () => (
  <PageLayout testId="our-story-page">
    <OurStory />
  </PageLayout>
);

export default OurStoryPage;
